import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class GoogleTagManagerService {
  private isLoaded = false;

  /**
   * Loads Google Tag Manager script if GTM ID is configured in environment
   * and hasn't been loaded yet
   */
  loadTagManager(): void {
    // Check if GTM ID is configured
    if (!environment.googleTagManagerId) {
      console.log('Google Tag Manager ID not configured, skipping load');
      return;
    }

    // Prevent loading multiple times
    if (this.isLoaded) {
      console.log('Google Tag Manager already loaded');
      return;
    }

    // Check if script already exists in DOM
    if (document.getElementById('google-tag-manager-script')) {
      this.isLoaded = true;
      return;
    }

    const gtmId = environment.googleTagManagerId;

    // Create and inject GTM script
    const script = document.createElement('script');
    script.id = 'google-tag-manager-script';
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
    script.onload = () => {
      this.isLoaded = true;
      console.log('Google Tag Manager loaded successfully');
    };
    script.onerror = () => {
      console.error('Failed to load Google Tag Manager');
    };

    // Create noscript fallback
    const noscript = document.createElement('noscript');
    const iframe = document.createElement('iframe');
    iframe.src = `https://www.googletagmanager.com/ns.html?id=${gtmId}`;
    iframe.height = '0';
    iframe.width = '0';
    iframe.style.display = 'none';
    iframe.style.visibility = 'hidden';
    noscript.appendChild(iframe);

    // Inject into head and body
    document.head.appendChild(script);
    document.body.insertBefore(noscript, document.body.firstChild);
  }
}
